import { render, staticRenderFns } from "./RepresentativePopover.vue?vue&type=template&id=b5341138&"
import script from "./RepresentativePopover.vue?vue&type=script&lang=js&"
export * from "./RepresentativePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports